import { Subject_SubjectEnum } from '@protos/common/common.db_pb';
import { SubjectList } from '@protos/user_management/ums.login.apis_pb';
import { useLocation } from 'react-router-dom';

function useLocationKey(key: string): string | undefined;
function useLocationKey(key: string, type: 'number'): number | undefined;
function useLocationKey(key: string, type: 'bigint'): bigint | undefined;
function useLocationKey(
  key: string,
  type?: 'number' | 'bigint'
): string | number | bigint | undefined {
  const location = useLocation();
  const val = new URLSearchParams(location.search).get(key);

  if (!val) return undefined;

  switch (type) {
    case 'number':
      return parseFloat(val);
    case 'bigint':
      return BigInt(val);
    default:
      return val;
  }
}

export { useLocationKey };

interface SubjectListItem {
  subjectName: string;
  id: number;
}
export const getSubjectList = (
  subjectList?: SubjectList[]
): SubjectListItem[] | undefined => {
  if (subjectList && subjectList?.length > 0) {
    const arr = subjectList.map((e) => ({
      id: e.subjectId,
      subjectName: e.subjectName,
    }));
    return arr;
  }
  return undefined;
};

// =============================================================

export const getSubjectEnumFromStringEnum = (
  subjectParam?: string
): Subject_SubjectEnum | undefined => {
  if (!subjectParam) {
    return undefined;
  }
  const enumValue =
    Subject_SubjectEnum[
      subjectParam.trim().toUpperCase() as keyof typeof Subject_SubjectEnum
    ];

  return typeof enumValue === 'number' ? enumValue : undefined;
};

// =============================================================

export const currentSessionMode = (props: {
  reduxSessionMode?: 'learn' | 'assess';
}) => {
  const { reduxSessionMode } = props;

  return reduxSessionMode;
};

// =============================================================
